export default __webpack_public_path__ + "static/media/LimitedEditIcon.20134801.svg";